import {
  FollowupFields,
  FollowupListParams,
} from "../../view/Modules/Followups/FollowupDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const FollowupServices = {
  getFollowups: (params: FollowupListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.FOLLOWUPS, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.FOLLOWUPS, { params });
  },

  createFollowup: (data: FollowupFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_FOLLOWUP, data),
  updateFollowup: (id: number, data: FollowupFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_FOLLOWUP.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),

  deleteFollowup: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_FOLLOWUP.replace(":id", id.toString())
    ),

  viewFollowup: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_FOLLOWUP.replace(":id", id.toString())
    );
  },

  updateComment: (id: number, data: any) =>
    AxiosInstance.put(
      ContentApiRoutes.UPDATE_FOLLOWUP_COMMENT.replace(":id", id.toString()),
      data
    ),

  deleteComment: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_FOLLOWUP_COMMENT.replace(":id", id.toString())
    ),
};
